(function(){
  'use strict';
  var KEY='mg_recent';
  function safe(fn){try{return fn();}catch(e){return null;}}
  function readList(){var v=safe(function(){return JSON.parse(localStorage.getItem(KEY)||'[]');});return Array.isArray(v)?v:[];}
  function writeList(list){safe(function(){localStorage.setItem(KEY,JSON.stringify(list.slice(0,8)));});}
  function money(cents){
    var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';
    try{return new Intl.NumberFormat(document.documentElement.lang||'fr-FR',{style:'currency',currency:cur}).format(cents/100);}
    catch(e){return (cents/100).toFixed(2)+' '+cur;}
  }

  /* Vu récemment : mémorisé dans le navigateur du visiteur uniquement */
  function initRecent(){
    var root=document.querySelector('[data-mg-recent]');
    if(!root){return;}
    var cur=root.getAttribute('data-current')||'';
    var list=readList();
    if(cur){list=[cur].concat(list.filter(function(h){return h!==cur;}));writeList(list);}
    var limit=parseInt(root.getAttribute('data-limit'),10)||4;
    var handles=list.filter(function(h){return h!==cur;}).slice(0,limit+2);
    if(!handles.length){return;}
    var grid=root.querySelector('[data-mg-recent-grid]');
    var results=new Array(handles.length);
    var done=0;
    function render(){
      var items=results.filter(Boolean).slice(0,limit);
      if(!items.length||!grid){return;}
      items.forEach(function(p){
        var a=document.createElement('a');
        a.className='mg-rc';
        a.href='/products/'+p.handle;
        var wrap=document.createElement('span');
        wrap.className='mg-rc__img';
        if(p.featured_image){
          var img=document.createElement('img');
          img.src=p.featured_image+(p.featured_image.indexOf('?')>-1?'&':'?')+'width=480';
          img.alt='';
          img.loading='lazy';
          wrap.appendChild(img);
        }
        var t=document.createElement('span');
        t.className='mg-rc__title';
        t.textContent=p.title;
        var pr=document.createElement('span');
        pr.className='mg-rc__price';
        pr.textContent=(p.price_varies?'À partir de ':'')+money(p.price_min!==undefined?p.price_min:p.price);
        a.appendChild(wrap);a.appendChild(t);a.appendChild(pr);
        grid.appendChild(a);
      });
      root.hidden=false;
    }
    handles.forEach(function(h,i){
      fetch('/products/'+encodeURIComponent(h)+'.js',{headers:{'Accept':'application/json'}})
        .then(function(r){return r.ok?r.json():null;})
        .catch(function(){return null;})
        .then(function(p){results[i]=p;done++;if(done===handles.length){render();}});
    });
  }

  /* Chiffres qui montent quand ils arrivent à l'écran */
  function initCount(){
    var els=document.querySelectorAll('[data-mg-count]');
    if(!els.length){return;}
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduce||!('IntersectionObserver' in window)){return;}
    function fmt(n){return n.toLocaleString('fr-FR');}
    function run(el){
      var to=parseInt(el.getAttribute('data-mg-count'),10)||0;
      var t0=null;
      function step(t){
        if(t0===null){t0=t;}
        var k=Math.min((t-t0)/1200,1);
        el.textContent=fmt(Math.round(to*(1-Math.pow(1-k,3))));
        if(k<1){requestAnimationFrame(step);}
      }
      requestAnimationFrame(step);
    }
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){if(e.isIntersecting){run(e.target);io.unobserve(e.target);}});
    },{threshold:0.4});
    els.forEach(function(el){el.textContent='0';io.observe(el);});
  }

  /* Barre d'achat fixe : apparaît quand le bouton d'achat est sorti de l'écran */
  function initSticky(){
    var bar=document.querySelector('[data-mg-sticky]');
    if(!bar){return;}
    var target=document.querySelector('product-form')||document.querySelector('.product-form');
    if(!target){return;}
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){
        var e=es[0];
        bar.classList.toggle('is-visible',!e.isIntersecting&&e.boundingClientRect.top<0);
      }).observe(target);
    }
    var btn=bar.querySelector('[data-mg-sticky-btn]');
    if(btn){
      btn.addEventListener('click',function(ev){
        ev.preventDefault();
        target.scrollIntoView({behavior:'smooth',block:'center'});
      });
    }
  }

  function init(){initRecent();initCount();initSticky();}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
